:host {
  display: block;
}

.password {
  display: grid;
  gap: var(--sc-form-row-spacing, 0.75em);
  &__hint {
    padding-top: 0.36rem;
    color: red;
  }
}
